<template>
  <SectionContainer @edit="$emit('edit')" :hideEdit="hideEdit" :showEdit="showEditComputed" :showAdd="showAddComputed">

    <!-- Display Selected Interests Grouped by Category -->
    <div v-for="category in categoriesWithSelectedInterests" :key="category.key" class="mb-[10px]">
      <InfoRow>
        <template #label>
          <MultilanguageDisplay :value="category.name" />
        </template>
        <div v-if="category.selectedInterests.length">
          <p v-for="interest in category.selectedInterests" :key="interest.key">
            <MultilanguageDisplay :value="interest.name" />
          </p>
        </div>
      </InfoRow>
    </div>

    <!-- Display Other Interests -->
    <InfoRow :label="t('profile.other_interests')" v-if="otherInterests.length">
      <p v-for="interest in otherInterests" :key="interest">{{ interest }}</p>
    </InfoRow>

  </SectionContainer>
</template>

<script setup>
import { computed } from "vue";
import SectionContainer from "@/components/account/sections/SectionContainer.vue";
import InfoRow from "@/components/content/InfoRow.vue";
import MultilanguageDisplay from "@/components/core/content/MultilanguageDisplay.vue";
const { t } = useI18n();

const props = defineProps({
  selectedInterests: {
    type: Array,
    default: () => []
  },
  otherInterests: {
    type: Array,
    default: () => []
  },
  onboardingData: {
    type: Object,
    default: () => ({}),
  },
  showEdit: {
    type: Boolean,
    default: true
  },
  hideEdit: {
    type: Boolean,
    default: false
  },
});

// Categories with selected interests
const categoriesWithSelectedInterests = computed(() => {
  if (!props.onboardingData || !props.onboardingData.interests) {
    return [];
  }

  return props.onboardingData.interests.map((category) => {
    const selectedInterests = category.interests.filter((interest) =>
      props.selectedInterests.includes(interest.key)
    );

    return {
      ...category,
      selectedInterests,
    };
  }).filter(category => category.selectedInterests.length > 0);
});

// Computed property to determine if showEdit should be true
const showEditComputed = computed(() => {
  return !(categoriesWithSelectedInterests.value.length === 0 &&
    props.otherInterests.length === 0);
});

// Computed property to determine if showAdd should be true
const showAddComputed = computed(() => {
  return categoriesWithSelectedInterests.value.length === 0 &&
    props.otherInterests.length === 0;
});

</script>

<style scoped></style>
